import {
  AnalyticsConfiguration,
  interactionEvent,
  pageViewAndError,
  pageViewEvent,
} from '@rci/self-serve-fido/core/analytics';

const modalPageName = 'modal - automatic payment discounts';
const changeMopToManualName = 'change payment method to manual';
const reviewChangeMopToManualName = 'review - change payment method to manual';
const deEnrollHierarchy = ['myaccount', 'payments', 'auto'];
const deEnrollModalName = 'modal - automatic payments discount removal';

const page = (name = 'overview', hierarchy = ['myaccount', 'overview']) => ({
  name,
  hierarchy,
});

const pageWithUrl = (name = modalPageName, hierarchy = ['myaccount', 'overview']) => ({
  name,
  hierarchy,
  url: 'modal popup',
});

const interaction = (name, type = 'click') => ({
  type,
  name,
});

export const autopayPromoAnalyticsConfig = {
  LearnMoreCTAConfig: {
    mappingKey: 'learnMoreCTA',
  },
  ApiFailureConfig: {
    mappingKey: 'apiFailure',
  },
  DiscountsModalConfig: {
    mappingKey: 'discountsModal',
  },
  SetupAutopayCTAConfig: {
    mappingKey: 'setupAutopayCTA',
  },
  CancelCTAConfig: {
    mappingKey: 'cancelCTA',
  },
  DeEnrollChangeMopCTAConfig: {
    mappingKey: 'deEnrollChangeMopCTA',
  },
  DeEnrollReviewChangeMopCTAConfig: {
    mappingKey: 'deEnrollReviewChangeMopCTA',
  },
  DeEnrollChangeMopApiFailureConfig: {
    mappingKey: 'deEnrollChangeMopApiFailure',
  },
  DeEnrollReviewChangeMopApiFailureConfig: {
    mappingKey: 'deEnrollReviewChangeMopApiFailure',
  },
  DeEnrollModalConfig: {
    mappingKey: 'deEnrollModal',
  },
  DeEnrollKeepAutopayCTA: {
    mappingKey: 'deEnrollKeepAutopayCTA',
  },
  DeEnrollContinueCTA: {
    mappingKey: 'deEnrollContinueCTA',
  },
  DeEnrollCancelCTA: {
    mappingKey: 'deEnrollCancelCTA',
  },
};

export const autopayPromoAnalyticsConfiguration: AnalyticsConfiguration = {
  mappings: {
    learnMoreCTA: {
      events: interactionEvent,
      page: page(),
      interaction: interaction('setup automatic payment discount banner - setup'),
    },
    apiFailure: {
      events: pageViewAndError,
      page: page(),
    },
    discountsModal: {
      events: pageViewEvent,
      page: pageWithUrl(),
    },
    setupAutopayCTA: {
      events: interactionEvent,
      page: page(modalPageName),
      interaction: interaction('automatic payment discounts modal - set up automatic payment'),
    },
    cancelCTA: {
      events: interactionEvent,
      page: page(modalPageName),
      interaction: interaction('automatic payment discounts modal - close'),
    },
    deEnrollChangeMopCTA: {
      events: interactionEvent,
      page: page(changeMopToManualName, deEnrollHierarchy),
      interaction: interaction('review impacted plans'),
    },
    deEnrollReviewChangeMopCTA: {
      events: interactionEvent,
      page: page(reviewChangeMopToManualName, deEnrollHierarchy),
      interaction: interaction('review impacted plans'),
    },
    deEnrollChangeMopApiFailure: {
      events: pageViewAndError,
      page: page(changeMopToManualName, deEnrollHierarchy),
    },
    deEnrollReviewChangeMopApiFailure: {
      events: pageViewAndError,
      page: page(reviewChangeMopToManualName, deEnrollHierarchy),
    },
    deEnrollModal: {
      events: pageViewEvent,
      page: pageWithUrl(deEnrollModalName, deEnrollHierarchy),
    },
    deEnrollKeepAutopayCTA: {
      events: interactionEvent,
      page: page(deEnrollModalName, deEnrollHierarchy),
      interaction: interaction('keep automatic payments'),
    },
    deEnrollContinueCTA: {
      events: interactionEvent,
      page: page(deEnrollModalName, deEnrollHierarchy),
      interaction: interaction('unsubscribe auto-pay - continue'),
    },
    deEnrollCancelCTA: {
      events: interactionEvent,
      page: page(deEnrollModalName, deEnrollHierarchy),
      interaction: interaction('unsubscribe auto-pay - close'),
    },
  },
};
